import { createRoot } from 'react-dom/client';
import HighlightedProjectCard from './HighlightedProjectCard.js';
import ImpactCard from './ImpactCard.js';
import GivingPageTabsController from '../../givingpage/GivingPageTabsController';

$(() => {
    let highlightedProjects = undefined;
    let impactData = undefined;
    let showPhotos = undefined;
    let impactLetterSectionPublished = false;
    const givingTabsDataElement = document.getElementById('js-givingTabs-data');
    const givingTabsPublished = JSON.parse(givingTabsDataElement.textContent);
    const campaignIdElement = document.getElementById('js-campaignId-data');
    const campaignId = JSON.parse(campaignIdElement.textContent);

    const EmptyImpactLetters = () => (
        <section id="impact-letters" className="empty-impact-letters-container">
            <div className="inside-container">
                <img
                    src="/images/partnerpage/empty-impact-letters.png"
                    alt="impact letters coming soon"
                />
                <h2>
                    Teachers will share the impact of this campaign here. Stay tuned for updates!
                </h2>
            </div>
            <div className="yellow-wave"></div>
        </section>
    );

    if(document.getElementById('js-highlighted-prj-data')) {
        const dataElement = document.getElementById('js-highlighted-prj-data');
        highlightedProjects = JSON.parse(dataElement.textContent);
    }

    if(document.getElementById('js-impact-data')) {
        impactLetterSectionPublished = true;
        const impactDataElement = document.getElementById('js-impact-data');
        impactData = JSON.parse(impactDataElement.textContent);
        const photoDataElement = document.getElementById('js-show-photos');
        showPhotos = JSON.parse(photoDataElement.textContent);
    }

    function isEmpty(data) {
        return data == null || data == undefined || data.length == 0;
    }

    const root = createRoot(document.getElementById('js-campaign'));

    root.render(<section className="padless-container">
        {impactLetterSectionPublished
            ? (isEmpty(impactData)
                ? <EmptyImpactLetters />
                : <ImpactCard impactData={impactData} showPhotos={showPhotos} campaignId={campaignId}/>)
            : null}
        {isEmpty(highlightedProjects) ? null :
            <HighlightedProjectCard highlightedProjects={highlightedProjects}/>}
        {givingTabsPublished ?
            <div className="campaign-page-all-supported-projects-container">
                <h2>All supported projects</h2>
                <div id="tabs"><GivingPageTabsController challenge={challenge} stats={stats}/></div>
            </div> : null}
    </section>);
});
